import * as yup from 'yup';
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from '@Shared/utils/validationSchema';

export interface IBankRiskManagementFormMeta2 {
  maxOffline: FormInputMeta,
  minTran: FormInputMeta,
  maxOnline: FormInputMeta,
  maxCumul: FormInputMeta,
  nbCumul: FormInputMeta,

  // Schema
  schema: any,
}

const BankRiskManagementFormMeta2: IBankRiskManagementFormMeta2 = {} as IBankRiskManagementFormMeta2

BankRiskManagementFormMeta2.maxOffline = {
  name: 'maxOffline',
  type: 'text',
  label: 'Max Offline',
  placeholder: 'Max ',
  validation: yup.string().required(),
};

BankRiskManagementFormMeta2.minTran = {
  name: 'minTran',
  type: 'text',
  label: 'Min Tran',
  placeholder: 'Min Tran',
  validation: yup.string().required(),
};

BankRiskManagementFormMeta2.maxOnline = {
  name: 'maxOnline',
  type: 'text',
  label: 'Max online',
  placeholder: 'Max online',
  validation: yup.string().required(),
};

BankRiskManagementFormMeta2.maxCumul = {
  name: 'maxCumul',
  type: 'text',
  label: 'Max Cumul',
  placeholder: 'Max Cumul',
  validation: yup.string().required(),
};

BankRiskManagementFormMeta2.nbCumul = {
  name: 'nbCumul',
  type: 'text',
  label: 'Nbr Cumul',
  placeholder: 'Nbr Cumul',
  validation: yup.string().required(),
};

const validationSchama = getValidationSchema(BankRiskManagementFormMeta2);

BankRiskManagementFormMeta2.schema = yup.object().shape(validationSchama);

export default BankRiskManagementFormMeta2;